<template>
  <van-sticky>
    <div class="tabar-nav">
      <div
        v-for="(item, index) in tabar"
        :key="index"
        @click="track(item.shenceEventName)"
      >
        <router-link v-if="item.status == 1" :to="item.path">{{
          item.name
        }}</router-link>
        <a v-if="item.status == 2" :href="item.path" target="_blank">{{
          item.name
        }}</a>
      </div>
    </div>
  </van-sticky>
  <!-- <van-dialog
    v-model:show="showDialog"
    title="提示"
    show-cancel-button
    @confirm="changeGeographic"
  >
    <div> 当前位置在【{{ position?.province }}】，是否切换？ </div>
  </van-dialog> -->
  <RouterView />
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';
import { RouterView } from 'vue-router';
import { usePositioningStore } from '@/stores';
import { useShenCe } from '@/utils/shence';

const { track } = useShenCe();

const tabar = ref<
  {
    path: string;
    name: string;
    status: number;
    shenceEventName: string;
  }[]
>();
const positioningStore = usePositioningStore();
tabar.value = positioningStore.getTabar();
watch(
  () => [positioningStore.firstChange],
  () => {
    tabar.value = positioningStore.getTabar();
  },
  {
    immediate: true,
  }
);
</script>

<style lang="scss" scoped>
.tabar-nav {
  display: flex;
  justify-content: space-between;
  padding: 20px;
  font-size: 32px;
  font-weight: 400;
  line-height: 38px;
  color: #fff;
  background: linear-gradient(90deg, #1975ff, #0133e1);

  a {
    color: #fff;

    &.router-link-active {
      position: relative;
      font-weight: 600;

      &::after {
        position: absolute;
        bottom: -12px;
        left: 50%;
        width: 50px;
        height: 2px;
        margin-left: -25px;
        content: '';
        background-color: #fff;
        border-radius: 33px;
        opacity: 1;
      }
    }
  }
}
</style>
